import React, { FC, ReactNode } from "react";
import { TemplateAsComponent } from "../../TemplateAsComponent";
import { CustomText } from "../../../types/graphql/generated";
import { StyledEmailOptIn, StyledExternalLink } from "./index.styled";

interface EmailOptInProps {
  customText: CustomText[];
  location: "checkout" | "signup";
}

export const EmailOptIn: FC<EmailOptInProps> = ({ customText, location }) => {
  const details = customText.find((info) => {
    return info.location === location && info.type === "emailOptIn";
  });

  if (!details) return null;

  const map = details.links.reduce<Record<string, ReactNode>>((links, link) => {
    const { key, displayValue, linkValue } = link;
    links[key] = (
      <StyledExternalLink href={linkValue} underline>
        {displayValue}
      </StyledExternalLink>
    );
    return links;
  }, {});

  return (
    <StyledEmailOptIn>
      {details.body.map((section) => (
        <TemplateAsComponent template={section} map={map} key={section} />
      ))}
    </StyledEmailOptIn>
  );
};
